import React from "react";

import { theme } from "../../../../theme/restyle/theme";
import { Pressable, Text } from "../../../primitive";
import { HStack } from "../../../primitive/Stack";
import { CountryCode } from "../utils/countryCodes";

export const CountryCodeItem = React.memo(
  ({
    ITEM_HEIGHT,
    countryCode,
    isSelected,
    isHovered,
    onPress,
    onHoverIn,
    onHoverOut,
  }: {
    ITEM_HEIGHT: number;
    countryCode: CountryCode;
    isSelected: boolean;
    isHovered: boolean;
    onPress: (code: CountryCode) => void;
    onHoverIn: () => void;
    onHoverOut: () => void;
  }) => {
    return (
      <Pressable
        onHoverIn={onHoverIn}
        onHoverOut={onHoverOut}
        style={{
          height: ITEM_HEIGHT,
          borderRadius: 8,
          backgroundColor:
            isHovered || isSelected
              ? theme.colors["surface-secondary"]
              : "transparent",
          justifyContent: "center",
        }}
        onPress={() => onPress(countryCode)}
      >
        <HStack
          gap={2}
          py={3}
          px={4}
          justifyContent="space-between"
          width={"100%"}
        >
          {/* flex={1} gives the name a width on native; without it the name collapses to 0 */}
          <HStack gap={2} alignItems="center" flex={1}>
            {countryCode.icon}
            <Text variant="mainBaseSemiBold" flex={1} numberOfLines={1}>
              {countryCode.name}
            </Text>
          </HStack>
          <HStack gap={2} alignItems="center">
            <Text variant="mainBaseMedium" color="text-secondary">
              +{countryCode.code}
            </Text>
          </HStack>
        </HStack>
      </Pressable>
    );
  }
);
